/**
 * V70G8J — 무인도 탈출 시도 표기 (표시 전용)
 *
 * 서버 상태 `trapFails` 는 0-based "실패 횟수"이고, 규칙은 TRAP_CONFIG 그대로다
 * (1·2차는 주사위 판정, 실패 2회 후 3차는 보장 탈출). 화면에는 "이번이 몇 번째 시도인지"를
 * 1-based 로 보여주며, 주사위 하단 버튼과 상단 HUD 가 같은 값을 쓴다.
 */
import { TRAP_CONFIG } from './config/eventConfig';

/** 최대 탈출 시도 횟수 (= 보장 직전 실패 허용 횟수 + 보장 시도 1회) */
export const TRAP_MAX_ATTEMPTS = TRAP_CONFIG.guaranteeAfterFails + 1;

/** 이번 시도 차수 (1 ~ TRAP_MAX_ATTEMPTS) */
export function trapAttemptNumber(trapFails: number): number {
  const fails = Number.isFinite(trapFails) && trapFails > 0 ? Math.floor(trapFails) : 0;
  return Math.min(fails + 1, TRAP_MAX_ATTEMPTS);
}

/** 이번 시도가 보장 탈출인지 (규칙 판정과 같은 기준) */
export function isGuaranteedTrapAttempt(trapFails: number): boolean {
  return trapFails >= TRAP_CONFIG.guaranteeAfterFails;
}

/** 주사위 하단 버튼: "탈출 시도 (1차/3차)" */
export function trapAttemptButtonLabel(trapFails: number): string {
  const label = `탈출 시도 (${trapAttemptNumber(trapFails)}차/${TRAP_MAX_ATTEMPTS}차)`;
  return isGuaranteedTrapAttempt(trapFails) ? `🚁 ${label}` : label;
}

/** 상단 정보창: "1/3" */
export function trapAttemptHudValue(trapFails: number): string {
  return `${trapAttemptNumber(trapFails)}/${TRAP_MAX_ATTEMPTS}`;
}
